import React from 'react';
export const CloseIcon = ({ color = "black", size = 24 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    style={{ color }}
  >
    <path
      d="M18.75 5.25L5.25 18.75"
      stroke="var(--theme-primary, #810EA9)"
      strokeWidth="2.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.75 18.75L5.25 5.25"
      stroke="var(--theme-primary, #810EA9)"
      strokeWidth="2.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
